import { createAsyncThunk } from "@reduxjs/toolkit";
import rolesURL from "../../../utils/url/roles";
//axios
import { AXIOS } from "../../../api/axios";

//error message
import responseError from "../../../utils/api/error-handling";

//get AllUser
export const getAllTranslations = createAsyncThunk(
  "role/getAllRoles",
  async (_, thunkAPI) => {
    try {
      const response = await AXIOS.get("https://test.syriajob.com/public/api/admin/translations");
      console.log(response.data.data);
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(responseError(error));
    }
  },
);
export const searshAllTranslations = createAsyncThunk(
  "role/searshAllTranslations",
  async({ ar_name }: { ar_name: string}, thunkAPI) => {
    try {
      const response = await AXIOS.get(`https://test.syriajob.com/public/api/admin/translations?ar_name=${ar_name}`);
      console.log(response.data.data);
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(responseError(error));
    }
  },
);
export const getOneTranslations = createAsyncThunk(
  "role/getAllRoles",
  async ({ id }: { id: string }, thunkAPI) => {
    try {
      const response = await AXIOS.get(`https://test.syriajob.com/public/api/admin/translations?id=${id}`);
      console.log(response.data.data);
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(responseError(error));
    }
  },
);


//GET ONE USER

export const getOneTranslation = createAsyncThunk(
  "role/getOneRole",
  async ({ id }: { id: string }, thunkAPI) => {
    try {
      const response = await AXIOS.get(`${rolesURL.GET_ROLE}${id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(responseError(error));
    }
  },
);

//EDIT ONE USER

export const editTranslation = createAsyncThunk(
  "role/editRole",
  async ({ id, data }: { id: number; data: any }, thunkAPI) => {
    try {
      const response = await AXIOS.post(`https://test.syriajob.com/public/api/admin/translations/${id}`, data);
      return response.data.result;
    } catch (error) {
      return thunkAPI.rejectWithValue(responseError(error));
    }
  },
);
export const addNewTranslation = createAsyncThunk(
  "role/addNewRoles",
  async (data: any, thunkAPI) => {
    try {
      const response = await AXIOS.post("https://test.syriajob.com/public/api/admin/translations", data);
      console.log(response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(responseError(error));
    }
  },
);

export const deleteTranslations = createAsyncThunk(
  "roles/deleteRoles",
  async ({ id }: { id: number }, thunkAPI) => {
    try {
      const response = await AXIOS.delete(`https://test.syriajob.com/public/api/admin/translations/${id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(responseError(error));
    }
  },
);

export const getPermission = createAsyncThunk(
  "roles/getPermission",
  async (_, thunkAPI) => {
    try {
      const response = await AXIOS.get(rolesURL.PERMISSIONS);
      console.log(response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(responseError(error));
    }
  },
);
